/* eslint-disable @typescript-eslint/naming-convention -- campos em snake_case espelham o contrato da API */
import { normalizeAttachment, normalizeChart } from '../utils/normalize-artifact.util';
import { IMessageAttachment, IMessageAttachmentRaw } from './message-attachment.interface';
import { IMessageChart } from './message-chart.interface';
import {
  IMessageReference,
  IMessageReferenceRaw,
  toMessageReference
} from './message-reference.interface';

export type ConversationMessageRole = 'user' | 'agent';

export type ConversationMessageType = 'text' | 'confirmation' | 'confirmation_response';

export interface IConversationMessageViewRaw {
  id: string;
  role: ConversationMessageRole;
  content: string;
  type?: ConversationMessageType;
  skill_title?: string | null;
  timestamp: string;
  is_error?: boolean;
  attachments?: IMessageAttachmentRaw[];
  charts?: Array<IMessageChart | Record<string, unknown>>;
  references?: IMessageReferenceRaw[];
  is_partial?: boolean;
}
export interface IConversationMessageView {
  id: string;
  role: ConversationMessageRole;
  content: string;
  type?: ConversationMessageType;
  quickActionTitle?: string | null;
  timestamp: string;
  isError?: boolean;
  attachments?: IMessageAttachment[];
  charts?: IMessageChart[];
  references?: IMessageReference[];
  isPartial: boolean;
}

export const toConversationMessageView = (raw: IConversationMessageViewRaw): IConversationMessageView => ({
  id: raw.id,
  role: raw.role,
  content: raw.content,
  type: raw.type ?? 'text',
  quickActionTitle: raw.skill_title,
  timestamp: raw.timestamp,
  isError: raw.is_error,
  attachments: raw.attachments?.map(normalizeAttachment).filter((a): a is IMessageAttachment => a !== null),
  charts: raw.charts?.map(normalizeChart).filter((c): c is IMessageChart => c !== null),
  references: raw.references?.map(toMessageReference),
  isPartial: raw.is_partial === true
});
